define('pages/user-page',["require", "exports", "../baseline/tables", "../baseline/upload", "../baseline/user-stats"], function (require, exports, tables, upload, userStats) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(userId) {
        tables.init(userId);
        upload.init();
        userStats.init(userId);
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/pages/user-page.js.map;
